export const EMAIL_SENT_SUCCCESS = 'Email enviado con éxito'
export const BROADCAST_SENT_SUCCCESS = 'Difusión enviada con éxito'
export const CONTACT_EMAIL_SUCCESS =
    'Gracias por contactarnos, le responderemos lo antes posible'
